import React from 'react';
import MuiCard from './MuiCard';

/**
 * Card component that wraps MUI Card
 * This component maintains the same API as the original Card component
 * but uses Material-UI under the hood
 */
const Card = ({
  children,
  variant = 'default',
  padding = 'md',
  header,
  actions,
  className = '',
  onClick,
  ...props
}) => {
  return (
    <MuiCard
      variant={variant}
      padding={padding}
      header={header}
      actions={actions}
      className={className}
      onClick={onClick}
      {...props}
    >
      {children}
    </MuiCard>
  );
};

export default Card;